import { render, staticRenderFns } from "./FooterLpSub.vue?vue&type=template&id=d73b4d78&"
import script from "./FooterLpSub.vue?vue&type=script&lang=js&"
export * from "./FooterLpSub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports